import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lt-png-table-selection-footer',
  imports: [CommonModule],
  template: `
      <div class="footer-info">
          @if(selectionCount() > 0) {
              <small class="text-primary fw-semibold">
                  <i class="pi pi-check-circle me-1"></i>
                  {{ selectionCount() }} selected
              </small>
          } @else {
              <small class="text-muted">Selection</small>
          }
      </div>
  `,
})
export class LTPngTableSelectionFooterComponent {
  selectionCount = input.required<number>();
}
